<div id="contents" role="main" data-ng-view="" class="ng-scope">
	<section class="flex_ctr_bx ng-scope">
		<div class="form_wrap sec_order_status" data-ng-show="vm.isComplete">
			<img src="./assets/images/scp_icon02.png">
			<!--h3 class="blind">Order Status</h3-->
				<h3 class="htit ng-binding" style="margin-top:20px;">
					<!--i class="sp img_compelete"></i-->
					<!--Hello, <em>{{contract.firstName}} {{contract.lastName}}</em>!-->
					Hello, <em>Dear Customer</em>!
				</h3>
					<p data-ng-bind-html="'text.hello.sub' | translate | htmlSafe">You are now covered by Samsung Care+</p>
					<div class="inner">
						<div class="order-detail-title">Your Coverage Status<div class="arrow-down"></div></div>
			<div class="sec status">
				
			
				<div class="status_bx">
					<ul>
						<li><span class="tit">CONTRACT NO</span><div>{{contract.contractNo}}</div></li>
						<li><span class="tit">PRODUCT</span><div>{{contract.skudesc}}</div></li>
						<li><span class="tit">COVERAGE</span><div>Additional {{contract.term}}-months coverage</div></li>
						<!-- 
						<li><span class="tit">PRODUCT</span>{{product.SKUDESC}}</li>
						<li><span class="tit">COVERAGE</span>{{product.TERM}}-months coverage</li>
						 -->
						<!-- <li><span class="tit">MODEL CODE</span>{{contract.modelCode}}</li> -->
						<li><span class="tit">SERIAL NO</span><div>{{contract.serialNo}}</div></li>
					</ul>
				</div>
			</div>
			<div class="sec">
				<div class="heading">
					<h3 class="h3">Start / End Date</h3>
					<div class="obj_right"><span>Registered : {{contract.orderDate}}</span></div>
				</div>
				<div class="start-date-wrapper">
					<div class="start-date">
						<span>Start Date:</span><span class="date">{{contract.contractStartDate}}</span>
					</div>
					<div class="end-date">
					<span>End Date:</span> <span class="date">{{contract.contractEndDate}}</span>
					</div>

				</div>
				<div class="duration">
				<div class="due_area"><span class="today" style="left: {{percentDay}}%;"><span
					class="drop"><em>Today</em></span></span></div>
					</div>
			</div>
			<div class="sec">
				<div class="col2">
					<h3 class="h3"><span>Payment</span>
					</h3>
					<div class="col2_inner">
						<div class="payment">
							<ul>
								<li>
									<h4 class="h3">SINGLEPAY</h4>
								</li>
								<li>
									<strong>{{contract.contractStatus}}</strong>
								</li>
								<li>
									<div class="clearfix">
										<div *ngIf="contract.cancelAvailable" class="btn-wrap">
											<a (click)="onCancellation()" style="color:#003399;"><u>Cancellation Request</u></a>
										</div>
									</div>
								</li>
							</ul>
						</div>
						<div *ngIf="contract.cancelDesc != null" class="col2_inner">
							{{contract.cancelDesc}}
						</div>
					</div>
				</div>
				<!--div class="col2">
					<h3 class="h3"><span>Additional</span><i></i></h3>
					<div class="col2_inner">
						<div class="additional">
							<h4 class="h4">Samsung Care+</h4>
							<ul class="links">
								<li><a target="_blank"
										data-ng-href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/"
										href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/">Terms
										and
										Conditions</a></li>
								<li><a target="_blank" data-ng-href="https://www.samsung.com/us/account/privacy-policy/"
										href="https://www.samsung.com/us/account/privacy-policy/">Privacy Policy</a>
								</li>
								<li data-ng-if="('display.orderStatus.call' | translate) == 'true'" class=" ng-scope">For
									further support, please contact us on 1-866-371-9501.</li>
							</ul>
						</div>
					</div>
				</div-->
			</div>
		</div>
		<div class="needhelp">
			<h3>Need Help?</h3>
			<p>If you have any question or need help with your order, please contact us at 866-371-9501</p>
			<div class="terms-link">
				<ul>
					<li><a target="_blank"
							data-ng-href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/"
							href="https://www.asurion.com/pdf/samsung-after-market-for-consumer-electronics/">Terms
							and
							Conditions</a></li>
					<li><a target="_blank" data-ng-href="https://www.samsung.com/us/account/privacy-policy/"
							href="https://www.samsung.com/us/account/privacy-policy/">Privacy Policy</a>
					</li>
					<li>
						<div class="clearfix">
							<div class="btn-wrap">
								<a (click)="onResend()" style="color:#003399;"><u>Resend Sales Receipt</u></a>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="btn_area">
			<a href="#" class="btn btn_type2 ng-binding ng-scope"><img src="./assets/images/button-arrow-pre.png">Back to Home</a>
		</div>
		</div>
	</section>
</div>